import * as angular from 'angular';

class IconSelectFieldController {}

export const IconSelectFieldComponent: angular.IComponentOptions = {
  controller: IconSelectFieldController,
  controllerAs: 'ctrl',
  bindings: {
    ariaLabel: '@',
    onChange: '&',
    options: '<',
    selected: '<',
    title: '@',
  },
  template: `
    <!-- Use i-* class prefix instead of icon-* to prevent css conflicts -->
    <div class="i-select-field">
      <select-field
        selected="ctrl.selected"
        options="ctrl.options"
        on-change="ctrl.onChange({ $option })"
        title="{{ctrl.title}}"
      >
        <select-field-control>
          <span class="i-select-field-control icon-gear-outlined-dark align-md-icon mdlg-icon">
            <span class="visually-hidden">
              {{ ctrl.ariaLabel }}
            </span>
          </span>
        </select-field-control>
      </select-field>
    </div>
  `,
};
